export function Toggle({
  checked,
  onChange,
  label,
  ariaLabel,
  disabled = false,
  describedBy,
}: Readonly<{
  checked: boolean
  onChange: (next: boolean) => void
  label?: string
  /** The switch's accessible name when its visible label sits elsewhere. */
  ariaLabel?: string
  /** Shown but not operable — the setting is fixed. */
  disabled?: boolean
  /** Id of the element that explains the switch, rendered as
   * `aria-describedby`. */
  describedBy?: string
}>) {
  return (
    <label
      className={`inline-flex items-center gap-2 select-none ${disabled ? 'cursor-default' : 'cursor-pointer'}`}
    >
      {label && <span className="text-[13px] text-[var(--text-primary)]">{label}</span>}
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={ariaLabel}
        aria-describedby={describedBy}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={`w-10 h-[22px] rounded-full relative transition-colors shrink-0 disabled:cursor-default disabled:opacity-40 ${
          checked ? 'bg-[var(--accent)]' : 'bg-[var(--border)]'
        }`}
      >
        <span
          className={`absolute top-[2px] left-[2px] w-[18px] h-[18px] rounded-full bg-white transition-transform ${
            checked ? 'translate-x-[18px]' : ''
          }`}
        />
      </button>
    </label>
  )
}
